export const inputBaseTheme = {
  input: {
    fontSize: 14,
    lineHeight: 1,
    height: '15px !important',
    '&.MuiInputBase-inputMultiline': {
      lineHeight: 1.4,
    },
    '&.MuiSelect-select': {
      lineHeight: 1.4,
    },
    '&:-webkit-autofill': {
      transitionDelay: '9999s',
      transitionProperty: 'background-color, color',
      bkitBoxShadow: 'none!important',
    },
    '&::-webkit-clear-button': {
      display: 'none',
    },
    '&::-webkit-inner-spin-button': {
      WebkitAppearance: 'none',
      margin: 0,
    },
    '&::-webkit-outer-spin-button': {
      WebkitAppearance: 'none',
      margin: 0,
    },
    '&:focus': {
      outline: 'none',
    },
    '&.MuiSelect-outlined': {
      padding: '13.9px 14px',
    },
  },
}

export const outlinedInputTheme = {
  notchedOutline: {
    borderWidth: 1.5,
    borderRadius: 8,
    // borderColor: alpha(colors.black, 0.5),
  },
}
